<!--
  @component
  Generates an SVG multi-series line chart. It expects your data to be an array of objects, each with a `values` key that is an array of data objects.
 -->
<script>
	import { fade } from "svelte/transition";
	import { tweened } from "svelte/motion";
	import { quintOut } from "svelte/easing";
	import { getContext } from "svelte";
	import { interpolateString } from "d3-interpolate";
	import { platform } from "../../../../components/MediaQuerySsr.svelte";

	import { max } from "d3-array";

	export let path;
	export let lineDrawDuration;
	export let group;

	const { zGet, xScale, extents, width, yRange, yGet } = getContext("LayerCake");

	let area = path;
	$: gradientId = `${group.topic.replaceAll(" ", "").replaceAll(",", "")}-gradient`;
	$: {
		area = (values) => {
			return (
				path(values) +
				("L" +
					$xScale($extents.x ? $extents.x[1] : 0) +
					"," +
					$yRange[0] +
					"L" +
					$xScale($extents.x ? $extents.x[0] : 0) +
					"," +
					$yRange[0] +
					"Z")
			);
		};
	}

	let tD = tweened(area(group.values), { interpolate: interpolateString, duration: 300 });
	$: targetD = area(group.values);
	$: tD.set(targetD, { interpolate: interpolateString, duration: 300 });

	$: fill = group.settings.trendline ? $zGet(group) : $platform === "mobile" ? "none" : `url(#${gradientId})`;
</script>

<path in:fade={{ duration: 100, delay: lineDrawDuration, ease: quintOut }} class="path-line" d={$tD} {fill} />
<defs>
	<linearGradient id={gradientId} x1={$width} y1={0} x2={$width} y2={$yRange[0]} gradientUnits="userSpaceOnUse">
		<stop stop-color={$zGet(group)} stop-opacity="1" />
		<stop offset="0.7" stop-color={$zGet(group)} stop-opacity="0.7" />
		<stop offset="1" stop-color={$zGet(group)} stop-opacity="0" />
	</linearGradient>
</defs>

<style>
	.path-line {
		stroke: none;
		opacity: 0.4;
	}
</style>
